module.exports = __webpack_public_path__ + "static/media/XIXh.0839f524.png";